import { Formik } from "formik";
import * as Yup from "yup";
import { Button, Form, Modal } from "react-bootstrap";
import { LoadingSpinner  } from "../generalLayout";
import { useState } from "react";
import { sendDataToEmailApi } from "../../api/contactFormApi";

// form validation schema (with Yup)
const validationSchema = Yup.object().shape({
  name: Yup.string().required("Please enter a name"),
  email: Yup.string()
    .email("Please enter a valid email address")
    .required("Please enter an email address"),
  message: Yup.string().required("Please enter a message"),
});

export default function ContactFormModal(props) {
  const [show, setShow] = useState(true);

  const formFields = [
    { name: "name", label: "Name", type: "text" },
    { name: "email", label: "Email", type: "text" },
    { name: "message", label: "Message", type: "textarea" },
  ];

  const handleSubmitClick = async (values) => {
    // modal form that allows users to submit a contact message to the website
    
    try {
      await sendDataToEmailApi(values);
      props?.setSuccessMsg("Thank you for contacting us! We will get back to you as soon as possible.")
      props?.setShowContactForm(false);
    } catch (error) {
      props?.setErrorMsg(
        "Your message could not be submitted. Please try again later."
      );
      props?.setShowContactForm(false);
    }
  };

  return (
    <Modal
      size="md"
      show={show}
      onHide={() => setShow(false)}
      backdrop="static"
      keyboard={false}
      centered
    >
      <Modal.Header style={{display: "block"}}>
        <Modal.Title
          style={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
          }}
        >
          <h2>Contact Form</h2>
          <Button
            variant="light"
            onClick={() => {
              setShow(false);
              props?.setShowContactForm(false);
            }}
          >
            <i className="bi bi-x-lg"></i>
          </Button>
        </Modal.Title>
        <p style={{marginTop: "1rem", marginBottom: "0"}}>Please leave us a message and we will get back to you as soon as possible.</p>
      </Modal.Header>

      <Modal.Body>
        <Formik
          initialValues={{
            name: "",
            email: "",
            message: "",
          }}
          validationSchema={validationSchema}
          onSubmit={async (values, { setSubmitting }) => {
            // API call to Formspree
            await handleSubmitClick(values);
            setSubmitting(false);
          }}
        >
          {({
            handleSubmit,
            handleChange,
            values,
            touched,
            errors,
            isSubmitting,
          }) => (
            <Form noValidate onSubmit={handleSubmit}>
              {formFields.map((field, idx) => (
                <Form.Group key={idx} className="mb-3" controlId={field.name}>
                  <Form.Label
                  // className={field.name === "password" ? "mt-4" : ""}
                  >
                    {field.label}
                  </Form.Label>
                  {field.type === "textarea" ? (
                    <Form.Control
                      as="textarea"
                      name={field.name}
                      rows={3}
                      maxLength={1000}
                      value={values[field.name]}
                      onChange={handleChange}
                      isInvalid={touched[field.name] && !!errors[field.name]} //errors.email
                    />
                  ) : (
                    <Form.Control //regular field
                      type={field.type}
                      name={field.name}
                      maxLength={100}
                      value={values[field.name]}
                      onChange={handleChange}
                      isInvalid={touched[field.name] && !!errors[field.name]} //errors.email
                    />
                  )}
                  <Form.Control.Feedback type="invalid">
                    {errors[field.name]}
                  </Form.Control.Feedback>
                </Form.Group>
              ))}
              <Button type="submit">
                {isSubmitting && (
                  <LoadingSpinner button={true} variant="primary" />
                )}{" "}
                Send
              </Button>
            </Form>
          )}
        </Formik>
      </Modal.Body>
    </Modal>
  );
}
